import { render } from "./manage_client.html?vue&type=template&id=6f0b56ab&external"
import script from "./manage_client.js?vue&type=script&lang=js&external"
export * from "./manage_client.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__